import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "@/stores/notificationStore";
import { LoadingFallback } from "@/components/ui/LoadingFallback";

/**
 * NotFoundRedirect Component
 * Intercepts dead links, notifies the user, and redirects to the landing page.
 */
export const NotFoundRedirect = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // 1. Notify the user in Hebrew (Spirit Research Lab tone)
        toast.error("העמוד המבוקש לא נמצא. מעבירים אותך לדף הבית.");

        // 2. Perform the redirect
        const timer = setTimeout(() => {
            navigate("/", { replace: true });
        }, 1500); // Brief delay to allow the toast to be noticed

        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div className="flex flex-col items-center justify-center min-h-[60vh]">
            <LoadingFallback />
        </div>
    );
};
